import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../theme';

export default StyleSheet.create({
  text: {
    marginBottom: 12,
    alignSelf: 'flex-end',
    marginHorizontal: 16,
    fontFamily: textStyles.regular,
    fontSize: 13,
    color: colorPalette.grey7,
  },
});
